import { forwardRef, Ref, type SVGProps } from 'react';

const SvgSumthingIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 28 32"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#sumthing-icon_svg__a)">
      <path d="M27.259 23.354q0 3.57-2.58 6.108t-6.21 2.537H0v-9.072l6.164-2.605H0V8.645q0-3.592 2.58-6.107Q5.16 0 8.79 0h18.47v9.073l-6.164 2.604h6.163z" />
    </g>
    <defs>
      <clipPath id="sumthing-icon_svg__a">
        <path d="M0 0h27.259v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgSumthingIcon);
export default ForwardRef;
